<template>
  <div id="app">
    <router-view :fonts-ready="fontsReady"/>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapState } from 'vuex'
  import store from './store'
  import Spy from '@/lib/Spy'
  import * as FontFaceObserver from 'fontfaceobserver'
  import { Bus, colors } from '@/lib/consts'
  import { randInt } from '@/lib/funcs'
  import DummyGNav from '@/components/DummyGNav'

  export default {
    name: 'app',
    store,
    data () {
      return {
        fontsReady: false,
        wurflInt: 0,
        wurfl: {},
        spy: {},
        orientationCount: 0
      }
    },
    computed: {
      ...mapState( {
        deviceModel: state => state.device.model,
        deviceBrowser: state => state.device.browser,
        deviceFormFactor: state => state.device.formFactor,
        didView: state => state.report.didView
      } )
    },
    watch: {
      spy ( spy ) {
        if ( spy ) {
          store.dispatch( 'setCity', spy.location ).then( () => {
            store.commit( 'setBrowser', spy.browser )
            store.commit( 'setModel', spy.device )
            store.commit( 'setFormFactor', this.wurfl.form_factor )
          } )
        }
      }
    },
    methods: {

      checkFonts () {
        let acCheck = new FontFaceObserver( 'adobe-clean' )
        let acsCheck = new FontFaceObserver( 'adobe-clean-serif' )
        let ko50Check = new FontFaceObserver( 'Knockout 50 A' )
        let ko30Check = new FontFaceObserver( 'Knockout 30 A' )

        Promise.all( [ acCheck.load(), acsCheck.load(), ko50Check.load(), ko30Check.load() ] ).then( () => {
          this.fontsReady = true
        }, () => console.warn( 'fonts failed to load after 3 seconds' ) )
      },

      loadWurfl () {
        let wfd = document.createElement( 'script' )
        wfd.type = 'text/javascript'
        wfd.src = '//wurfl.io/wurfl.js'
        document.body.appendChild( wfd )
      },

      checkMobile () {
        this.wurfl.is_mobile === true && (this.wurfl.form_factor === 'Smartphone' || this.wurfl.form_factor === 'Tablet')
          ? store.dispatch( 'setIsMobile', true )
          : store.dispatch( 'setIsMobile', false )
      },

      checkOrientation ( rotation ) {
        if ( this.orientationCount < 3 ) {
          if ( rotation.alpha === null && rotation.beta === null && rotation.gamma === null ) {
            store.dispatch( 'setDemoCapable', false )
          } else {
            store.dispatch( 'setDemoCapable', true )
          }
          this.orientationCount++
        } else {
          window.removeEventListener( 'deviceorientation', this.checkOrientation )
        }
      },

      pickRandomColor () {
        // Pick random, except for the red one which clashes with the Adobe logo
        let c = randInt( 0, colors.length )
        if ( c === 3 ) {
          return this.pickRandomColor()
        }
        return c
      }

    },
    created () {
      this.checkFonts()
      this.loadWurfl()
    },
    mounted () {
      this.wurflInt = setInterval( () => {
        if ( window.WURFL ) {
          this.wurfl = window.WURFL

          this.checkMobile()

          this.spy = new Spy()
          clearInterval( this.wurflInt )
        }
      }, 100 )

      document.body.classList.remove( 'hide-gnav' )

      this.$store.dispatch( 'setWinSize' )
      this.$nextTick( () => Bus.$emit( 'resized' ) )

      // randomize colors on refresh after vuex-persistedstate rehydrates only if report.didView is false
      if ( !this.didView ) this.$store.dispatch( 'setColors', this.pickRandomColor() )

      window.addEventListener( 'resize', _.debounce( () => {
        this.$store.dispatch( 'setWinSize' )
        this.$nextTick( () => Bus.$emit( 'resized' ) )
      }, 150 ) )

      // Initial capabilities check
      if ( !window.DeviceMotionEvent || !window.DeviceOrientationEvent ) {
        this.$store.dispatch( 'setDemoCapable', false )
      }
      window.addEventListener( 'deviceorientation', this.checkOrientation )
    },
    components: { DummyGNav }
  }
</script>

<style lang="scss">
  @import "assets/scss/main.scss";

  #AdobePrimaryNav {
    transition : opacity 0s 0s ease !important;
  }

  body {
    > div[class^='Gnav-'] {
      z-index  : 1000;
      position : absolute;
      width    : 100%;
      top      : 0;
      left     : 0;
    }

    &.hide-gnav {
      #AdobePrimaryNav {
        opacity : 0 !important;
      }
    }

    &.show-gnav {
      #AdobePrimaryNav, .report-nav-container {
        opacity : 1 !important;
      }

      #AdobePrimaryNav {
        transition-duration : 1s !important;
        transition-delay    : 0.35s !important;
      }

      .report-nav-container {
        transition-delay : 1.35s;
      }
    }
  }

  #app {
    font-family : $adobe-clean;
    height      : 100%;

    .logo-vector {
      max-height : 200px;
      max-width  : 226px;
    }

    .device {
      position : fixed;
      top      : 20px;
      left     : 20px;
      z-index  : 200;
      color    : $black;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue